import styled from 'styled-components';
import { PriceBoxStyled } from '../PriceBoxStyled';

export const PriceBoxStyledAP = styled(PriceBoxStyled)``;
